import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import * as moment from "moment";
import React, { useState } from "react";
import ActionBar from "../components/ActionBar";
import DateRangeSelector from "../components/DatePicker";
import Loader from "../components/Loader";
import MatrixView from "../components/MatrixView";
import PopupImage from "../components/PopupImage";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";
import { height } from "@amcharts/amcharts4/.internal/core/utils/Utils";

class HistoricImagesScreen extends VLComponent {

    constructor() {
        super();
        let columns = parseInt(localStorage.getItem("mat-cols"));
        if (isNaN(columns) || columns == null || columns < 2 || columns > 8) {
            columns = 4;
        }
        this.state = { images: [], loaded: false, columns, camera_name: "", oldest_image: "", viewingImage: {} };
    }

    componentDidMount() {
        this.fetch();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id != this.props.id || prevProps.date != this.props.date) {
            this.fetch();
        }
    }

    fetch = () => {
        this.setState({ loaded: false });
        API.POST("systems/historicImages", { sensor_id: this.props.id, date: this.props.date }, result => {
            Util.handleLogout(result);
            if (result.success) {
                let images = result.result.images;
                if (images.length == 0) {
                    this.basicAlert("No images available for this date", () => {
                        window.history.back();
                    });
                }
                this.setState({ images: images, camera_name: result.result.camera_name, oldest_image: result.result.oldest_image, loaded: true });
            }
        });
    };

    zoomOut = () => {
        let columns = Math.min(this.state.columns + 1, 8);
        this.setState({ columns });
        localStorage.setItem("mat-cols", columns);
    };

    zoomIn = () => {
        let columns = Math.max(this.state.columns - 1, 2);
        this.setState({ columns });
        localStorage.setItem("mat-cols", columns);
    };

    nextDay = () => {
        let unix = moment.unix(this.props.date).add(1, "days").unix();
        if (unix > Util.rn()) {
            return;
        }
        this.props.navigate("/camera/" + this.props.id + "/images/" + unix);
    };

    goToOldest = () => {
        if (!this.state.oldest_image) return;
        const unix = moment(this.state.oldest_image, "YYYY-MM-DD").startOf("day").unix();
        this.props.navigate(`/camera/` + this.props.id + `/images/` + unix);
    };

    previousDay = () => {
        let unix = moment.unix(this.props.date).add(-1, "days").unix();
        this.props.navigate("/camera/" + this.props.id + "/images/" + unix);
    };

    today = () => {
        let unix = moment().startOf("day").unix();
        this.props.navigate("/camera/" + this.props.id + "/images/" + unix);
    };

    backToDetails = () => {
        this.props.navigate("/camera/" + this.props.id);
    };

    render() {
        return (
            <div>
                <ActionBar title={"Historic Images - " + this.state.camera_name} />
                {this.renderTextAlert()}
                {this.state.downloadingImages && <ImageDownloader start={this.props.date} onClose={() => this.setState({ downloadingImages: false })} cameraID={this.props.id} />}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    height: "calc(100vh - 64px)",
                    flexDirection: "column",
                    padding: "24px 24px 0 24px",
                    overflowY: "hidden"
                }}>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "25% 50% 25%",
                        alignItems: "center",
                        width: "100%",
                        margin: "0 auto",
                        paddingBottom: 8
                    }}>
                        {/* Left column */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", gap: "8px" }}>
                            <VLButton title="Previous Day" onClick={this.previousDay} style={{ height: "fit-content" }} />
                            <VLButton title="Today" onClick={this.today} style={{ height: "fit-content" }} />
                            <VLButton title="Next Day" onClick={this.nextDay} style={{ height: "fit-content" }} />
                        </div>

                        {/* Center column */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                            <p style={{ fontSize: 20, textAlign: "center", margin: 0 }}>
                                <b>{this.title()}</b>
                            </p>
                        </div>

                        {/* Right column */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", gap: "8px" }}>
                            <VLButton style={{ height: "fit-content" }} title="Download Images" onClick={this.onDownload} />
                            <VLButton style={{ height: "fit-content" }} onClick={this.zoomOut} title="Zoom -" />
                            <VLButton style={{ height: "fit-content" }} onClick={this.zoomIn} title="Zoom +" />
                            <VLButton title="Oldest Image" onClick={this.goToOldest} style={{ height: "fit-content" }} />
                        </div>
                    </div>

                    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 24 }}>
                        <MatrixView images={this.getImages()} columns={this.state.columns} />
                    </div>
                    {this.state.viewingImage.image &&
                        <PopupImage url={this.state.viewingImage.image} close={() => this.setState({ viewingImage: {} })}
                            canDelete={Util.isAdmin() && !Util.isSubAccount()} deleteImage={this.deleteImage} />}
                </div>
                <Loader loaded={this.state.loaded} />
            </div>
        );
    }

    title = () => {
        if (this.props.hour == null) {
            return moment.unix(this.props.date).format("Do MMM YYYY");
        }
        let hour = this.props.hour;
        let next = hour == 23 ? "0" : (1 + parseInt(hour));
        return moment.unix(this.props.date).format("Do MMM YYYY") + " " + hour + ":00 - " + next + ":00";
    };

    getImages = () => {
        let mapper = i => ({
            id: i.date,
            url: i.image,
            title: i.date,
            overlay: i.deleted ? "DELETED" : "",
            background: window.primary,
            onClick: () => this.clickedImage(i)
        });

        const shouldCategorise = this.props.hour == null && this.state.images.length > 30;

        if (shouldCategorise) {
            let list = [];
            let lastHour = 25;
            this.state.images.forEach(i => {
                let date = i.unix;
                let hourS = moment.unix(date).format("HH");
                let hour = parseInt(hourS);
                let day = moment.unix(date).format("DD MMM");
                day += " " + hour + ":00 - " + (hour == 23 ? 0 : (hour + 1)) + ":00";
                if (hour < lastHour) {
                    let j = { ...i };
                    j.date = day;
                    j.category = true;
                    list.push(j);
                    lastHour = hour;
                }
            });
            return list.map(mapper);
        } else {
            return this.state.images.filter(i => {
                let date = i.unix;
                let hourS = moment.unix(date).format("HH");
                let hour = parseInt(hourS);
                return hour == this.props.hour || this.props.hour == null;
            }).map(mapper);
        }
    };

    clickedImage = (i) => {
        if (i.category) {
            let date = i.unix;
            let hour = moment.unix(date).format("HH");
            this.props.navigate("/camera/" + this.props.id + "/images/" + this.props.date + "/" + hour);
        } else {
            if (i.deleted) {
                this.basicAlert("This image has been deleted");
                return;
            }
            this.setState({ viewingImage: i });
        }
    };

    deleteImage = () => {
        const i = this.state.viewingImage;
        const data = {
            time: i.unix,
            camera_id: this.props.id
        };
        if (window.confirm("Are you sure you want to delete this image?")) {
            API.POST("systems/deleteImage", data, result => {
                if (result.success) {
                    this.setState({ viewingImage: {} });
                    this.fetch();
                } else {
                    this.basicAlert(result.error);
                }
            });
        }
    };

    onDownload = () => {
        this.setState({ downloadingImages: true });
    };

}

const ImageDownloader = ({ start, onClose, cameraID }) => {

    const STATE_NONE = 0;
    const STATE_LOADING = 1;
    const STATE_DONE = 2;

    const today = moment.unix(start).startOf("day").unix();
    const yesterday = moment.unix(start).add(-1, "days").startOf("day").unix();

    const [startDate, setStartDate] = useState(yesterday);
    const [endDate, setEndDate] = useState(today);
    const [email, setEmail] = useState("");

    const [error, setError] = useState("");
    const [state, setState] = useState(STATE_NONE);

    const doDownload = () => {
        if (!Util.isEmailValid(email)) {
            setError("Invalid email");
        } else if (endDate < startDate) {
            setError("End date cannot be before start date");
        } else {
            setError("");
            const params = { start: startDate, end: endDate, cameraID, email };
            params.token = Util.getJwt();
            setState(STATE_LOADING);
            API.POST("systems/downloadImages", params, () => {
                setState(STATE_DONE);
            });
        }
    };

    if (state === STATE_DONE) {
        return (
            <Dialog fullWidth maxWidth="sm" open>
                <DialogTitle>Download Images</DialogTitle>
                <DialogContent>
                    <p>An email with the requested images will be sent to <strong>{email}</strong>.</p>
                    <p>It may take up to 5 minutes to process your request, so please allow a few minutes for it to arrive.</p>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        );
    }

    if (state === STATE_LOADING) {
        return (
            <Dialog fullWidth maxWidth="sm" open>
                <DialogTitle>Download Images</DialogTitle>
                <DialogContent>
                    <p>Please wait</p>
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <Dialog fullWidth maxWidth="sm" open>
            <DialogTitle>Download Images</DialogTitle>
            <DialogContent>
                <p>Make a request for all images within a time range. Once the images are ready, you will be emailed a link to download them.</p>
                <DateRangeSelector start={startDate} end={endDate} onChange={e => {
                    setStartDate(e[0]);
                    setEndDate(e[1]);
                }} />
                <TextField style={{ margin: "8px 28px", width: "calc(100% - 54px)" }} type="email" label="Email to send images to" color="primary"
                    value={email} onChange={e => setEmail(e.target.value)} />
                <p style={{ color: "red" }}>{error}</p>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={onClose}>Cancel</Button>
                <Button color="primary" onClick={doDownload}>Download</Button>
            </DialogActions>
        </Dialog>
    );

};

export default HistoricImagesScreen;
